import React, { ReactNode } from 'react';
import './style.css';

const Container = ({
  style,
  children,
}: {
  style?: any;
  children: ReactNode;
}) => {
  return (
    <div className="app-container" style={style}>
      {children}
    </div>
  );
};

Container.Scrollable = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => {
  return (
    <div className={`app-container-scrollable ${className}`}>{children}</div>
  );
};

export default Container;
